module.exports = __webpack_public_path__ + "videos/invite-sent-136px.9557a57.webm";